module.exports = __webpack_public_path__ + "static/media/bytt-no-21.c5748edc.mp3";